import { Component } from '@angular/core';

@Component({
    selector: 'app-cta-section',
    standalone: true,
    templateUrl: './cta-section.component.html',
    styleUrls: ['./cta-section.component.css']
})
export class CtaSectionComponent {
    //  Configurá estos datos
    phoneNumber = '5491112345678'; // Tu número con código de país
    email = 'contacto@lightcapgroup.com.ar'; // Tu email

    defaultMessage = 'Hola! Me gustaría obtener más información sobre sus servicios.';

    get whatsappUrl(): string {
        return `https://wa.me/${this.phoneNumber}?text=${encodeURIComponent(this.defaultMessage)}`;
    }
}